import * as constants from "../constants";
import { ACTION } from "../shared/models/action";

export const setSidebar = (payload: boolean): ACTION => ({
  type: constants.SIDEBAR_SET,
  payload,
});

export const setPopup = (payload: boolean): ACTION => ({
  type: constants.POPUP,
  payload,
});

export const setLoading = (payload: boolean): ACTION => ({
  type: constants.LOADING,
  payload,
});

export const setRolesPageNo = (payload: boolean): ACTION => ({
  type: constants.SET_ROLES_PAGE_NO,
  payload,
});

export const setSessionsPageNo = (payload: boolean): ACTION => ({
  type: constants.SET_ROLES_PAGE_NO,
  payload,
});

// possible method are: set, add or remove.
// export const setSessionsOrderCriteria = (payload: Record<string, unknown>): ACTION => ({
//   type: SET_ORDER_CRITERIA_SESSIONS,
//   payload,
// });

// export const setSessionsFilterCriteria = (payload: Record<string, unknown>): ACTION => ({
//   type: SET_FILTERING_CRITERIA_SESSIONS,
//   payload,
// });
